const config = require("../config");
const api = require("../config/api");
const axios = require("axios");
const _ = require("lodash");

const actionType = "chaojima-home-article-news-read";
//
module.exports = {
  get: async (id) => {
    const params = {};
    params.actionType = actionType;
    // params.dataPage = `/detail?id=${id}`;
    params.itemId = id;
    params.pageType = "jgwcjm-article-news";
    params.dataPage = "/about/us.html#4";
    params.organizationId = config.organizationId;
    const res = await axios.get(api.common.statistics.get, { params });
    // console.log(JSON.stringify(res.data, null, 2));
    return 20;
  },
  save: async (id) => {
    const params = {};
    params.actionType = actionType;
    params.dataPage = `/detail?id=${id}`;
    // params.dataPointId = '';
    params.itemDescription = `甲骨文超级码官网[文章/新闻]的访问量统计,id:${id}`;
    params.itemId = id;
    params.operator = "";
    params.organizationId = config.organizationId;
    params.pageType = "chaojima-home-article-news";
    params.dataPage = `/news/detail/${id}`;
    params.sysId = config.systemId;
    const res = await axios.post(api.common.statistics.save, params);
    return _.get(res, "data");
  },
  login: async (account, password) => {
    const params = {};
    params.account = account;
    params.password = password;
    const res = await axios.post(api.common.statistics.qk_login, params);
    return res;
  },
  check: async (code) => {
    const params = {};
    params.fakeCode = code;
    const res = await axios.get(api.common.checkout, params);
    return res;
  },
  // clound_login: async () => {
  //   const params = {};
  //   params.account = actionType;
  //   params.password = `/detail?id=${id}`;
  //   const res = await axios.post(api.common.statistics.clound_login, params);
  //   return _.get(res, "data");
  // },
};
